// extracted by mini-css-extract-plugin
export default {"container":"tZ-z","heading":"uZ-z","links":"vZ-z","copy":"wZ-z","subCopy":"xZ-z","linksLeft":"yZ-z","linksCenter":"zZ-z","linksRight":"AZ-z","link":"BZ-z","onlyLink":"CZ-z"};